import { api } from '@/services/api'
import { SET, PUSH, MERGE, DELETE_ITEM_ARRAY, MERGE_ARRAY, MERGE_REVERSE_ARRAY, MERGE_ITEM_ARRAY } from '@/plugins/store/mutationTypes'

const state = {
  listRFQ1: [],
  listRFQ3: [],
  dataViewRFQ: {}
}
const getters = {
  mapListRFQ3: (state) => {
    return state['listRFQ3'].reduce((result, item) => {
      result[item.rfqid + '__' + item.partID] = item
      return result
    }, {})
  }
}
const mutations = {
  SET,
  PUSH,
  MERGE,
  DELETE_ITEM_ARRAY,
  MERGE_ARRAY,
  MERGE_ITEM_ARRAY,
  MERGE_REVERSE_ARRAY
}
const actions = {
  resetState ({ commit }) {
    return Promise.resolve()
      .then(() => {
        commit('SET', { key: 'listRFQ1', value: [] })
        commit('SET', { key: 'listRFQ3', value: [] })
      })
  },
  addRFQ1ToRFQ3 ({ commit, getters }, data) {
    let _data = { ...data }
    delete _data.id
    return api
      .post(`RFQ3s/Create`, JSON.parse(JSON.stringify(_data)))
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
